import React,{Component} from 'react';
import {variables} from '../../Variables.js';
import Alert from "../../components/Alert";
import MyPage from "../../../src/MyPage";
import SubTabsGeneralParams from "../../../src/SubTabsGeneralParams";
import axiosService from '../../helpers/axios';


  export default class GeneralParamsTransfertsFilter extends Component{ 

    constructor(props){
      super(props);

      this.state={
        costgridfilter:[],
        modalTitle:"",
            recordtffilterid: 0,
            lotnamefilter: "",
            lotidfilter: 0,
            subtasknamefilter: "",
            subtaskidfilter: 0,
            uomnamefilter: "",
            uomidfilter: 0,

            CostGridFilterIdFilter:"",
            LotNameFilter:"",
            LotIdFilter:"",
            SubTaskNameFilter:"",
            SubTaskIdFilter:"",
            UomNameFilter: "",
            UomIdFilter:"",

            
            costgridfilterWithoutFilter:[],
            lotNames:[],
            subtaskNames:[],
            uomNames:[]
        
      }
  }


  FilterFn(){
    var CostGridFilterIdFilter=this.state.CostGridFilterIdFilter;
    var LotNameFilter = this.state.LotNameFilter;
    var LotIdFilter = this.state.LotIdFilter;
    var SubTaskNameFilter = this.state.SubTaskNameFilter;
    var SubTaskIdFilter = this.state.SubTaskIdFilter;
    var UomNameFilter = this.state.UomNameFilter;
    var UomIdFilter = this.state.UomIdFilter;

    var filteredData=this.state.costgridfilterWithoutFilter.filter(
        function(el){
            return el.recordtffilterid.toString().toLowerCase().includes(
                CostGridFilterIdFilter.toString().trim().toLowerCase()
            )&&
            el.lotnamefilter.toString().toLowerCase().includes(
                LotNameFilter.toString().trim().toLowerCase()
            )&&
            el.lotidfilter.toString().toLowerCase().includes(
                LotIdFilter.toString().trim().toLowerCase()
            )&&
            el.subtasknamefilter.toString().toLowerCase().includes(
                SubTaskNameFilter.toString().trim().toLowerCase()
            )&&
            el.subtaskidfilter.toString().toLowerCase().includes(
                SubTaskIdFilter.toString().trim().toLowerCase()
            )&&
            el.uomnamefilter.toString().toLowerCase().includes(
                UomNameFilter.toString().trim().toLowerCase()
            )&&
            el.uomidfilter.toString().toLowerCase().includes(
                UomIdFilter.toString().trim().toLowerCase()
            )
        }
    );

    this.setState({costgridfilter:filteredData});

}

sortResult(prop,asc){
  var sortedData=this.state.costgridfilterWithoutFilter.sort(function(a,b){
      if(asc){
          return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
      }
      else{
          return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
      }
  });

  this.setState({costgridfilter:sortedData});

}

changeCostGridFilterIdFilter = (e)=>{
    this.state.CostGridFilterIdFilter=e.target.value;
    this.FilterFn();
  }

  changeLotNameFilter = (e)=>{
    this.state.LotNameFilter=e.target.value;
    this.FilterFn();
  }


  changeLotIdFilter = (e)=>{
    this.state.LotIdFilter=e.target.value;
    this.FilterFn();
  }
  

  changeSubTaskNameFilter = (e)=>{
    this.state.SubTaskNameFilter=e.target.value;
    this.FilterFn();
  }
  

changeSubTaskIdFilter = (e)=>{
  this.state.SubTaskIdFilter=e.target.value;
  this.FilterFn();
}


changeUomNameFilter = (e)=>{
  this.state.UomNameFilter=e.target.value;
  this.FilterFn();
}

changeUomIdFilter = (e)=>{
  this.state.UomIdFilter=e.target.value;
  this.FilterFn();
}




refreshList(){
  axiosService.get('/costgridtransfertsfilter/')
  .then(response=>{
      const data = response.data?.results ?? response.data;
      this.setState({costgridfilter:data,costgridfilterWithoutFilter:data});
  });
}


fetchLotNames() {
    axiosService.get('/costgridlots/')
      .then(response => {
        const data = response.data?.results ?? response.data;
        const lotNames = data.map(item => item.costgridlotname);
        this.setState({ lotNames: lotNames });
      })
      .catch(error => {
        console.error("Error fetching lotnames:", error);
      });
  }
  
  fetchSubTaskNames() {
    axiosService.get('/costgridsubtasks/')
      .then(response => {
        const data = response.data?.results ?? response.data;
        const subtaskNames = data.map(item => item.costgridsubtaskname);
        this.setState({ subtaskNames: subtaskNames });
      })
      .catch(error => {
        console.error("Error fetching subtasknames:", error);
      });
  }
  
  fetchUomNames() {
    axiosService.get('/costgriduoms/')
      .then(response => {
        const data = response.data?.results ?? response.data;
        const uomNames = data.map(item => item.uomname);
        this.setState({ uomNames: uomNames });
      })
      .catch(error => {
        console.error("Error fetching uomnames:", error);
      });
  }
  


fetchRegionNames() {
  axiosService.get('/regions/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const regionNames = data.map(item => item.regionname);
      this.setState({ regionNames: regionNames });
    })
    .catch(error => {
      console.error("Error fetching region names:", error);
    });
}

fetchRegionIdsCountries() {
  axiosService.get('/countries/') // Replace with the appropriate API endpoint for products
    .then((response) => {
      const data = response.data?.results ?? response.data;
      const uniqueRegionIdsCountries = [...new Set(data.map((item) => item.region.regionid))];
      this.setState({ uniqueRegionIdsCountries: uniqueRegionIdsCountries });
    })
    .catch((error) => {
      console.error('Error fetching countries data:', error);
    });
}

checkRegionExists = (event) => {
  const enteredRegion = event.target.value.toLowerCase(); // Convert to lowercase
  const { regionNames } = this.state;
  const regionExists = regionNames.some((region) => region.toLowerCase() === enteredRegion);
  this.setState({ regionExists });
};


checkRegionNameExistsCountries = (event) => {
  const enteredRegionName = event.target.value.toLowerCase(); // Convert to lowercase
  const { uniqueRegionIdsCountries} = this.state;

  const regionNameExistsCountries = uniqueRegionIdsCountries.some((productdescription) => productdescription.toLowerCase() === enteredRegionName);

  this.setState({ regionNameExistsCountries: regionNameExistsCountries });
};

componentDidMount(){
  this.refreshList();
  this.fetchRegionNames();
  this.fetchRegionIdsCountries();
  this.fetchLotNames();
  this.fetchSubTaskNames();
  this.fetchUomNames();
}

changeLotName =(e)=>{
  this.setState({lotnamefilter:e.target.value});
}

changeLotId =(e)=>{
  this.setState({lotidfilter:e.target.value});
}


changeSubTaskName =(e)=>{
    this.setState({subtasknamefilter:e.target.value});
  }

changeSubTaskId =(e)=>{
    this.setState({subtaskidfilter:e.target.value});
  }
  
  changeUomName =(e)=>{
    this.setState({uomnamefilter:e.target.value});
  }

  changeUomId=(e)=>{
    this.setState({uomidfilter:e.target.value});
  }



addClick(){
  this.setState({
      modalTitle:"Add Transfert CostGridFilter",
      recordtffilterid: 0,
      lotnamefilter: "",
      subtasknamefilter: "",
      uomnamefilter: ""
      
  });
}
editClick(dep) {
  this.setState({
    modalTitle: "Edit Transfert CostGridFilter",
    recordtffilterid: dep.recordtffilterid,
    lotnamefilter: dep.lotnamefilter,
    subtasknamefilter: dep.subtasknamefilter,
    uomnamefilter:dep.uomnamefilter,

    initialLotnamefilter: dep.lotnamefilter,
    initialSubtasknamefilter: dep.subtasknamefilter,
    initialUomnamefilter: dep.uomnamefilter,

  });
}

createClick() {
  const { lotnamefilter, subtasknamefilter, uomnamefilter,  } = this.state;




  axiosService.post('/costgridtransfertsfilter/', {
        lotnamefilter: lotnamefilter,
        subtasknamefilter: subtasknamefilter,
        uomnamefilter: uomnamefilter
  })
    .then(result => {
      alert('Transfert CostGridFilter created');
      this.refreshList();
      //window.location.reload();
    })
    .catch(error => {
      alert('Failed');
    });
}

updateClick(id) {
  const { lotnamefilter, subtasknamefilter, uomnamefilter, initialLotnamefilter, initialSubtasknamefilter, initialUomnamefilter, regionNames } = this.state;

  // Check if any changes are detected
  if (
    lotnamefilter === initialLotnamefilter &&
    subtasknamefilter === initialSubtasknamefilter &&
    uomnamefilter === initialUomnamefilter
  ) {
    alert('No changes detected');
    return;
  }


  axiosService.patch('/costgridtransfertsfilter/' + id + '/', {
      recordtffilterid: this.state.recordtffilterid,
      lotnamefilter: this.state.lotnamefilter,
      subtasknamefilter: this.state.subtasknamefilter,
      uomnamefilter: this.state.uomnamefilter
  })
    .then(result => {
      alert('Update successful');
      this.refreshList();
      //window.location.reload(); // Refresh the page
    })
    .catch(error => {
      alert('Failed');
    });
}

deleteClick(id) {
    axiosService.delete('/costgridtransfertsfilter/' + id + '/')
      .then(res => {
        alert('Delete successful');
        this.refreshList();
        //window.location.reload();
      })
      .catch(error => {
        alert(error?.response?.data?.error || error?.message || 'Delete failed');
      });
}


render(){
  const {
      costgridfilter,
      recordtffilterid,
      modalTitle,
      lotnamefilter, 
      subtasknamefilter, 
      uomnamefilter,

  }=this.state;

  
 
  return(
    
<div className="scrollable-container">
<MyPage />
<SubTabsGeneralParams />
<div className="table-container-single">
<table className="table table-striped">
<thead>
<tr className="header-row-fixed">
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      <div className="d-flex flex-row align-items-center justify-content-center">
      <input className="form-control m-2"
       style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeCostGridFilterIdFilter}
      placeholder="Filter"/>
      
      </div>
      RecordFilterId
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "100px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeLotNameFilter}
      placeholder="Filter"/>

      </div>
      LotNameFilter
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeLotIdFilter}
      placeholder="Filter"/>

      </div>
      LotIdFilter
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "100px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeSubTaskNameFilter}
      placeholder="Filter"/>

      </div>
      SubTaskNameFilter
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeSubTaskIdFilter}
      placeholder="Filter"/>

      </div>
      SubTaskIdFilter
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "100px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeUomNameFilter}
      placeholder="Filter"/>

      </div>
      UomNameFilter
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeUomIdFilter}
      placeholder="Filter"/>

      </div>
      UomIdFilter
  </th>
  
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      Options
  </th>
</tr>
</thead>
<tbody>
  {costgridfilter.map(dep=>
      <tr key={dep.recordtffilterid} className="row-hover">
          <td className="table-text">{dep.recordtffilterid}</td>
          <td className="table-text">{dep.lotnamefilter}</td>
          <td className="table-text">{dep.lotidfilter}</td>
          <td className="table-text">{dep.subtasknamefilter}</td>
          <td className="table-text">{dep.subtaskidfilter}</td>
          <td className="table-text">{dep.uomnamefilter}</td>
          <td className="table-text">{dep.uomidfilter}</td>
          <td className="table-text">


          </td>
      </tr>
      )}
</tbody>
</table>
</div>

<div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" style={{ fontSize: "12px" }} >{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >LotName</span>
          <select
            className="form-select"
            value={this.state.lotnamefilter}
            onChange={(event) => this.setState({ lotnamefilter: event.target.value })}
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select lotname</option>
            {this.state.lotNames.map((lotname) => (
              <option key={lotname} value={lotname}>
                {lotname}
              </option>
            ))}
          </select>
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >SubTaskName</span>
          <select
            className="form-select"
            value={this.state.subtasknamefilter}
            onChange={(event) => this.setState({ subtasknamefilter: event.target.value })}
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select subtaskname</option>
            {this.state.subtaskNames.map((subtaskname) => (
              <option key={subtaskname} value={subtaskname}>
                {subtaskname}
              </option>
            ))}
          </select>
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >UomName</span>
          <select
            className="form-select"
            value={this.state.uomnamefilter}
            onChange={(event) => this.setState({ uomnamefilter: event.target.value })}
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select uomname</option>
            {this.state.uomNames.map((uomname) => (
              <option key={uomname} value={uomname}>
                {uomname}
              </option>
            ))}
          </select>
        </div>

        {recordtffilterid === 0 ? (
          <button type="button" className="btn btn-primary float-start" onClick={() => this.createClick()}>
            Create
          </button>
        ) : null}

        {recordtffilterid !== 0 ? (
          <button type="button" className="btn btn-primary float-start" onClick={() => this.updateClick(recordtffilterid)}>
            Update
          </button>
        ) : null}
      </div>
    </div>
  </div>
</div>


</div>


  )
}


  }




